'use strict';

class DashboardPanelController {
  constructor($scope,
              $q,
              $filter,
              $state,
              config,
              utils,
              DashboardDataProvider,
              ReportsService,
              ToastsService) {
    const $t = $filter('translate');

    angular.extend($scope, {});

    init();

    function init() {
      $scope.loading = true;

      $q.all([
        DashboardDataProvider.dashboardReportGroupResource.init()
      ])
        .then(() => {
          $scope.hasData = !!DashboardDataProvider.dashboardReportGroupResource;
          $scope.loading = false;
        }, (err) => {
          utils.handleApiError(err);
          $scope.hasData = false;
          $scope.loading = false;
        });
    }
  }
}

export default angular
  .module('main.dashboardPanel.controller', [])
  .controller('DashboardPanelController', DashboardPanelController)
  .name;
